import * as R from 'ramda'

export function filterMap<A, B>(fn: (value: A) => B | null, items: A[]): B[] {
    return R.reduce(
        (previous, item) => {
            const result = fn(item)
            return result !== null
                ? R.append(result, previous)
                : previous
        },
        [],
        items,
    )
}

export function findMap<A, B>(
    fn: (value: A) => B | null,
    items: A[]
): B | null {
    return R.reduce(
        (previous, item) => {
            const result = fn(item)
            return result !== null
                ? R.reduced(result)
                : null
        },
        null,
        items,
    )
}

export function indexedFilter<T>(
    fn: (index: number, value: T) => boolean,
    items: T[],
): T[] {
    const result = []
    for (let i = 0; i < items.length; i++) {
        if (fn(i, items[i])) {
            result.push(items[i])
        }
    }
    return result
}

export function indexedMap<A, B>(
    fn: (index: number, value: A) => B,
    items: A[],
): B[] {
    const result = []
    for (let i = 0; i < items.length; i++) {
        result.push(fn(i, items[i]))
    }
    return result
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Data/ArrayHelper.ts